/**
 * AppointmentResultsRoute — skin-aware switcher for /appointment-results.
 *
 * Cockpit  → Jobs-era restraint variant (AppointmentResultsCockpit)
 * Classic  → original AppointmentResults page, untouched
 */
import { useUISkin } from "@/data/UISkinContext";
import AppointmentResults from "./AppointmentResults";
import AppointmentResultsCockpit from "./AppointmentResultsCockpit";

export default function AppointmentResultsRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <AppointmentResultsCockpit />;
  return <AppointmentResults />;
}
